// src/components/Footer.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import './Footer.css';

const footerLinks = [
  { name: '網站首頁', path: '/' },
  { name: '教會簡介', path: '/about' },
  { name: '聚會時間', path: '/schedule' },
  { name: '查經資料', path: '/bible-study-materials' },
  { name: '牧者的話', path: '/pastor-messages' },
  { name: '講台信息', path: '/sermon-messages' },
  { name: '見證分享', path: '/testimonies' },
  { name: '標竿刊物', path: '/articles' },
  { name: '聯絡我們', path: '/contact' },
  { name: '教會影視', path: '/church-media' },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-links">
        {footerLinks.map((link) => (
          <NavLink to={link.path} key={link.name}>
            {link.name}
          </NavLink>
        ))}
      </div>
      <p>
        © The Home of Christ Church in San Francisco. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;
